import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IPagination } from '../../../../modules/authorization/store/types';
import { ILog, ILogFilters } from 'src/app/modules/logged/logs/store/types';

@Injectable({
    providedIn: 'root'
})
export class LogService {

    constructor(private apiService: ApiService) { }

    public fetchAll(data: ILogFilters): Observable<IPagination<ILog>> {
        return this.apiService.get('/logs', data);
    }

}
